/* Machine Ltd — Übermilk return-on-investment calculator.
   Reads its starting values and the machine price from data- attributes on [data-ml-calc]. */
(function () {
  function money(n) {
    return '$' + Math.round(n).toLocaleString('en-NZ');
  }

  function init(root) {
    if (root.dataset.mlReady) return;
    root.dataset.mlReady = '1';
    var price = parseFloat(root.dataset.price) || 0;
    var inputs = root.querySelectorAll('input[data-key]');

    var formats = {
      drinks: function (v) { return v + ' / day'; },
      days: function (v) { return v + ' days'; },
      milkml: function (v) { return v + ' ml'; },
      milkcost: function (v) { return '$' + v.toFixed(2) + ' / L'; },
      waste: function (v) { return v + '%'; },
      seconds: function (v) { return v + ' sec'; },
      wage: function (v) { return '$' + v + ' / hr'; }
    };

    function read() {
      var v = {};
      inputs.forEach(function (el) {
        var n = parseFloat(el.value);
        v[el.dataset.key] = n;
        var out = root.querySelector('output[data-for="' + el.dataset.key + '"]');
        if (out) out.textContent = formats[el.dataset.key] ? formats[el.dataset.key](n) : n;
      });
      return v;
    }

    function calc() {
      var v = read();
      var weeksPerYear = 52;
      var drinksPerYear = v.drinks * v.days * weeksPerYear;
      var litresServed = drinksPerYear * v.milkml / 1000;
      // Milk you currently pour away, on top of what is served
      var litresWasted = litresServed * (v.waste / 100);
      var milkSaving = litresWasted * v.milkcost;
      var hoursSaved = drinksPerYear * v.seconds / 3600;
      var labourValue = hoursSaved * v.wage;
      var tradingDays = v.days * weeksPerYear;
      var consumables = (v.consumables || 0) * tradingDays;
      var total = milkSaving + labourValue - consumables;
      var paybackMonths = total > 0 ? price / (total / 12) : 0;

      set('total', money(total));
      set('milk', money(milkSaving) + ' · ' + Math.round(litresWasted).toLocaleString('en-NZ') + ' L');
      set('labour', money(labourValue) + ' · ' + Math.round(hoursSaved).toLocaleString('en-NZ') + ' hrs');
      set('consumables', '−' + money(consumables));
      set('payback', total > 0 ? (paybackMonths < 1 ? 'Under 1 month' : paybackMonths.toFixed(1) + ' months') : '—');
      set('drinksyr', Math.round(drinksPerYear).toLocaleString('en-NZ'));
    }

    function set(key, text) {
      var el = root.querySelector('[data-out="' + key + '"]');
      if (el) el.textContent = text;
    }

    inputs.forEach(function (el) { el.addEventListener('input', calc); });
    calc();
  }

  function boot() { document.querySelectorAll('[data-ml-calc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Re-initialise when the section is re-rendered in the Shopify theme editor
  document.addEventListener('shopify:section:load', boot);
})();
